import { render } from "./ChatConnectionError.vue?vue&type=template&id=9f43330e"
import script from "./ChatConnectionError.vue?vue&type=script&lang=js"
export * from "./ChatConnectionError.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__